import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import HotChartServices from '../../../services/HotChartServices';

function AddHotChart() {
    const [formValues, setFormValues] = useState({
        symbol: '',
        description: '',
        image: '',
    });
    const navigate = useNavigate();
    const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormValues((prev) => ({ ...prev, image: file }));

            const reader = new FileReader();
            reader.onloadend = () => setPreviewImage(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, value]) => {
                formData.append(key, value);
            });

            const response = await HotChartServices.createHotChart(formData);
            console.log('HotChart created:', response);
            alert('HotChart added successfully');
            navigate('/admin/hotChart')
            // Reset form
            setFormValues({ symbol: '', description: '', image: '' });
            setPreviewImage('img/placeholder-img.png');
        } catch (error) {
            console.error('Error adding HotChart:', error);
            alert('Failed to add HotChart');
        }
    };

    return (
        <div className="right_col" role="main">
            <div className="title-box">
                <h2>Hot Chart Add</h2>
                <div className="container-box-top-header-right">
                    <Link className="list-banner-btn" to="/admin/hotChart">Hot Chart List</Link>
                </div>
            </div>

            <div className="container-box px-5">
                <div className="container-box-inner">
                    <div className="page-details">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-9 col-md-6">
                                    <div className="input-field">
                                        <label>Symbol</label>
                                        <input
                                            type="text"
                                            name="symbol"
                                            className="form-control"
                                            value={formValues.symbol}
                                            onChange={handleInputChange}
                                            placeholder="New symbol"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-sm-12">
                                    <div className="input-field">
                                        <label>Description</label>
                                        <textarea
                                            className="form-control video-desc"
                                            name="description"
                                            value={formValues.description}
                                            onChange={handleInputChange}
                                            placeholder="New description"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-sm-12">
                                    <div className="input-field">
                                        <label>Upload <span className="red">*</span></label>
                                        <input
                                            type="file"
                                            name="image"
                                            className="form-control"
                                            accept="image/png, image/jpeg, image/jpg, image/webp"
                                            onChange={handleFileChange}
                                            required
                                        />
                                        <p>
                                            <span>Drop an image or Paste URL (up to 1500 x 1500 px),</span>
                                            Supported formats: png, jpeg, jpg, webp
                                        </p>
                                        <div className="file-preview text-center">
                                            <img id="uploadFile" src={previewImage} alt="Preview" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <button className="submit-green-btn" type="submit">Add HotChart</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddHotChart;
